module.exports = __webpack_public_path__ + "img/veribase-logo.0d4eaf1f.svg";